// extracted by mini-css-extract-plugin
export var borderRadius = "_fc-4";
export var large = "_fc-3";
export var logoContainer = "_fc-0";
export var nameLogo = "_fc-2";
export var small = "_fc-1";